import { ManufacturersGridView } from '~/components/catalog/manufacturers/grid';
import { PageContainer } from '~/components/page-container';

export function Manufacturers() {
	return (
		<PageContainer>
			<ManufacturersGridView />
		</PageContainer>
	);
}
